import DirectusSDK from "@directus/sdk-js";

// const queryParams = {};
// if (window) {
// 	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
// 		queryParams[key] = value;
// 	});
// }

// let token;
// const directUs = localStorage.getItem('directus-sdk-js');
// if (directUs) {
// 	try {
// 		token = JSON.parse(directUs).token;
// 	} catch (e) {}
// }
const Server = new DirectusSDK({
    url: process.env.API_URL,
    project: 'polymind',
    mode: 'cookie',
	persist: true,
	tokenExpirationTime: 60 * 60 * 1000,
	// token
});

export default Server;
